module.exports = __webpack_public_path__ + "img/Picture23.15f8d55f.png";